import { useContext } from "react";
import ClientContext from "@contexts/Client.context";
import ConfigurationContext from "@contexts/Configuration.context";

export const useClientContext = () => useContext(ClientContext);
export const useConfigurationContext = () => useContext(ConfigurationContext);